import logger from '@/services/logger';
import { Capacitor } from '@capacitor/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { ref } from 'vue';

const isLandscape = ref(false);
export function useScreenOrientation() {
  const lockToPortrait = async () => {
    try {
      if (Capacitor.isNativePlatform()) {
        await ScreenOrientation.lock({ orientation: 'portrait' });
      }
    } catch (error) {
      logger.error({
        message: 'Error locking screen orientation',
        error: error as Error,
      });
    }
  };

  const lockToLandscape = async () => {
    try {
      if (Capacitor.isNativePlatform()) {
        await ScreenOrientation.lock({ orientation: 'landscape' });
      }
    } catch (error) {
      logger.error({
        message: 'Error locking screen orientation',
        error: error as Error,
      });
    }
  };

  const unlock = async () => {
    try {
      if (Capacitor.isNativePlatform()) {
        await ScreenOrientation.unlock();
      }
    } catch (error) {
      logger.error({
        message: 'Error unlocking screen orientation',
        error: error as Error,
      });
    }
  };

  return {
    isLandscape,
    lockToPortrait,
    lockToLandscape,
    unlock,
  };
}
